<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';

  defineProps<{
    name: string,
    link: string
  }>();
  const {b, e} = useCpBem('cp-nav-menu-recom-card');
</script>

<template>
    <div :class="b">
        <a :href="link" :class="e('a')" target="_self">
            <div :class="e('container')">
                <CpText variant="body-regular" type="primary">
                    {{ name }}
                </CpText>
            </div>
        </a>
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-recom-card {
    &__container {
      display: inline-flex;
      padding: $cp-gutter-small;
      border: 1px solid var(--color-neutral-extra-light);
      border-radius: 8px;
      width: 100%;
    }
    &__a {
      text-decoration: none;
    }
  }
</style>
